import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';
import { decodeDataProps } from '@finn-no/tjt-common-utils';
import { I18nProvider } from '@lingui/react';
import i18n from '../locales/loadTranslations';
import App from './App';
import { Dataset } from './utils/dataProps';
import 'uno.css';

(() => {
    const webComponent = document.querySelector('tjt-podlet-frontpage-isolated');
    const shadowroot = webComponent?.shadowRoot;
    if (!shadowroot) return; // When user is not logged in

    const container = shadowroot.querySelector('#tjt-podlet-frontpage') as HTMLElement;
    const decodedDataProps = decodeDataProps<Dataset>(container);
    if (!(container && decodedDataProps)) return;

    i18n.activate(decodedDataProps?.lang || 'nb');
    const root = createRoot(container);

    root.render(
        ReactDOM.createPortal(
            <>
                <link href={decodedDataProps?.styleLink} rel="stylesheet" type="text/css" />
                <I18nProvider i18n={i18n}>
                    <App uiData={decodedDataProps?.uiData?.sections} />
                </I18nProvider>
            </>,
            container,
        ),
    );
})();
